import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Redirect, withRouter } from 'react-router-dom'
import { Collapse, message } from 'antd'
import AdminLayout from '../../components/AdminLayout'
import SectionHeader from '../../components/SectionHeader'
import SectionHeaderTemplate from '../../components/SectionHeaderTemplate'
import SectionContent from '../../components/SectionContent'
import Spin from '../../components/Spin'
import Form from './Form'
import SellerMenuForm from './SellerMenuForm'
import {
  editForm,
  fetchItem,
  createItem,
  editItem,
  deleteItem,
  reset,
} from '../../actions/userForm'

import {
  fetchItems as fetchSellerMenuItems,
  editSellerMenuForm,
  editItem as editSellerItem,
  reset as resetSellerMenu,
} from '../../actions/userSellerMenuForm'
import './index.less'

const { Panel } = Collapse

const listPath = '/admin/users'
const itemsTitle = 'Пользователи'
const itemTitle = 'пользователем'
const itemTitleCreate = 'пользователя'
const storeKey = 'userForm'
// Add module/
const storeSellerMenuKey = 'userSellerMenuForm'
//* *********/

class ItemForm extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.handleFormOnSubmit = this.handleFormOnSubmit.bind(this)
    this.handleFormOnDelete = this.handleFormOnDelete.bind(this)
    // Add module/
    this.state = { activeKeyPanel: '0' }
    this.props.resetSellerMenu()
    //* *********/
    this.props.reset()
  }

  componentDidMount() {
    if (this.props.type === 'edit') {
      this.props.fetchItem({ id: this.props.match.params.itemId })
      console.log(this.props.match.params.itemId)
      if (this.props.match.params.itemId !== '1' && this.props.match.params.itemId !== '5' && this.props.match.params.itemId !== '24' && this.props.match.params.itemId !== '25') {
        this.props.fetchSellerMenuItems({ idnum: this.props.match.params.itemId })
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isCreateItemLoading && nextProps.isCreateItemSuccess) {
      message.success('Новый пользователь успешно создан.')
    } else if (this.props.isEditItemLoading && nextProps.isEditItemSuccess) {
      message.success('Данные пользователя успешно изменены.')
    } else if (this.props.isDeleteItemLoading && nextProps.isDeleteItemSuccess) {
      message.success('Пользователь успешно удален.')
    } else if (this.props.isCreateItemLoading && nextProps.createItemError) {
      message.error(nextProps.createItemError)
    } else if (this.props.isEditItemLoading && nextProps.editItemError) {
      message.error(nextProps.editItemError)
    } else if (this.props.isDeleteItemLoading && nextProps.deleteItemError) {
      message.error(nextProps.deleteItemError)
    // Add module/
    } else if (this.props.isEditSellerMenuItemLoading && nextProps.isEditSellerMenuItemSuccess) {
      // message.success('Параметр успешно изменен.')
      // this.setState({
      //   activeKeyPanel: "0"
      // });
    } else if (this.props.isEditSellerMenuItemLoading && nextProps.editSellerMenuItemError) {
      message.error(nextProps.editSellerMenuItemError)
    //* *********/
    } else if (this.props.isFetchItemLoading && nextProps.fetchItemError) {
      message.error(nextProps.fetchItemError)
    }
  }

  handleFormOnSubmit(values) {
    if (this.props.type === 'create') {
      this.props.createItem(values)
    } else {
      const item = { ...this.props.item, ...values }
      this.props.editItem(item)
    }
  }

  handleFormOnDelete() {
    this.props.deleteItem({ id: this.props.match.params.itemId })
  }
  // Add module/
  handleSellerMenuOnChange(idnum, values) {
    const item = { f_seller: idnum, f_user: this.userId, n_enable: values ? '1' : '0' }
    this.editSellerItem(item)
  }
  //* *********/

  render() {
    const { type, isCreateItemSuccess, isDeleteItemSuccess } = this.props
    const { activeKeyPanel } = this.state

    const isCreateForm = type === 'create'
    const actionTitle = isCreateForm ? 'Создать' : 'Управление'
    // Add module/
    const handleChangeKeyPanel = (e) => {
      this.setState({
        activeKeyPanel: e,
      })
    }
    //* *********/
    if (isCreateItemSuccess || isDeleteItemSuccess) {
      return <Redirect to={listPath} />
    }
    return (
      <div>
        <AdminLayout>
          <SectionHeader>
            <SectionHeaderTemplate
              breadcrumbRoutes={[{ path: '/admin', title: 'Главная' }, { path: listPath, title: itemsTitle }, { title: actionTitle }]}
              title={`${actionTitle} ${isCreateForm ? itemTitleCreate : itemTitle}`}
            />
          </SectionHeader>
          {!isCreateForm && !this.props.isFetchItemLoading && this.props.match.params.itemId !== '1' && this.props.match.params.itemId !== '5' && this.props.match.params.itemId !== '24' && this.props.match.params.itemId !== '25' &&
            <Collapse className='custom-collapse' accordion bordered={false} onChange={e => handleChangeKeyPanel(e)} activeKey={activeKeyPanel}>
              <Panel className='custom-accordion-panel' header='Управление торговыми сетями' key='1'>
                <SectionContent>
                  {(!this.props.isFetchSellerMenuItemsLoading && this.props.items) &&
                    this.props.items.map((item, key) =>
                      (<SellerMenuForm
                        key={key}
                        keyItem={key}
                        onFieldsChange={this.props.editSellerMenuForm}
                        formFieldValues={item}
                        onChange={this.handleSellerMenuOnChange}
                        isEditSellerMenuItemLoading={this.props.isEditSellerMenuItemLoading}
                        editSellerItem={this.props.editSellerItem}
                        userId={this.props.match.params.itemId}
                      />))}
                </SectionContent>
              </Panel>
            </Collapse>
          }
          <SectionContent>
            {
              this.props.isFetchItemLoading && <Spin />
            }
            {
              (isCreateForm || (!isCreateForm && this.props.item)) &&
              <Form
                onSubmit={this.handleFormOnSubmit}
                onDelete={this.handleFormOnDelete}
                onFieldsChange={this.props.editForm}
                formFieldValues={this.props.formFieldValues}
                isCreateItemLoading={this.props.isCreateItemLoading}
                isEditItemLoading={this.props.isEditItemLoading}
                isDeleteItemLoading={this.props.isDeleteItemLoading}
                type={this.props.type}
              />
            }
          </SectionContent>
        </AdminLayout>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const {
    formFieldValues,
    isFetchItemLoading,
    isEditItemLoading,
    isCreateItemLoading,
    isCreateItemSuccess,
    isEditItemSuccess,
    isDeleteItemLoading,
    isDeleteItemSuccess,
    item,
    fetchItemError,
    createItemError,
    editItemError,
    deleteItemError,
  } = state[storeKey]

  // Add module/
  const {
    items,
    formFieldSellerMenuValues,
    isFetchSellerMenuItemsLoading,
    fetchSellerMenuItemsError,
    isEditSellerMenuItemLoading,
    isEditSellerMenuItemSuccess,
    editSellerMenuItemError,
  } = state[storeSellerMenuKey]

  //* *********/
  return {
    isFetchItemLoading,
    formFieldValues,
    isEditItemLoading,
    isCreateItemLoading,
    isCreateItemSuccess,
    isEditItemSuccess,
    isDeleteItemLoading,
    isDeleteItemSuccess,
    item,
    // Add module/
    formFieldSellerMenuValues,
    isFetchSellerMenuItemsLoading,
    fetchSellerMenuItemsError,
    isEditSellerMenuItemLoading,
    isEditSellerMenuItemSuccess,
    editSellerMenuItemError,
    items,
    //* *********/
    fetchItemError,
    createItemError,
    editItemError,
    deleteItemError,
  }
}

const mapDispatchToProps = dispatch => ({
  createItem: params => dispatch(createItem(params)),
  editItem: params => dispatch(editItem(params)),
  fetchItem: params => dispatch(fetchItem(params)),
  deleteItem: params => dispatch(deleteItem(params)),
  editForm: formFieldsChange => dispatch(editForm(formFieldsChange)),
  // Add module/
  fetchSellerMenuItems: params => dispatch(fetchSellerMenuItems(params)),
  editSellerItem: params => dispatch(editSellerItem(params)),
  editSellerMenuForm: formFieldsChange => dispatch(editSellerMenuForm(formFieldsChange)),
  resetSellerMenu: () => dispatch(resetSellerMenu()),
  //* *********/
  reset: () => dispatch(reset()),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ItemForm))



// WEBPACK FOOTER //
// src/containers/UserForm/index.jsx